import script from "./NoMatch.vue?vue&type=script&setup=true&lang=js"
export * from "./NoMatch.vue?vue&type=script&setup=true&lang=js"

import "./NoMatch.vue?vue&type=style&index=0&id=e4a664f2&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4a664f2"]])

export default __exports__